<template>
  <v-app>
    <!-- Componente Header -->
    <Header />
    <!-- Router View -->
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/common/Header";

export default {
  components: { Header },
  name: "App",
  data: () => ({}),
};
</script>

<style>
/* Vue Router */
html{
  overflow-y: auto;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
